module.exports = __webpack_public_path__ + "img/3.c8aaa4c7.png";